import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "px-[34px]" }
const _hoisted_4 = { class: "mb-2 p-4 rounded-md bg-white/10 text-white/60" }
const _hoisted_5 = {
  key: 1,
  class: "px-[34px] grid grid-cols-3 grid-flow-col gap-2 justify-stretch mb-4"
}
const _hoisted_6 = { class: "backdrop-blur-xl bg-white/10 h-[90px] rounded cursor-pointer" }
const _hoisted_7 = { class: "flex flex-col items-center justify-center" }
const _hoisted_8 = { class: "font-sourcesanspro-semibold text-sm2 text-white" }
const _hoisted_9 = {
  key: 0,
  class: "backdrop-blur-xl bg-white/10 h-[90px] rounded cursor-pointer"
}
const _hoisted_10 = { class: "flex flex-col items-center justify-center" }
const _hoisted_11 = { class: "font-sourcesanspro-semibold text-sm2 text-white" }
const _hoisted_12 = { class: "backdrop-blur-xl bg-white/10 h-[90px] rounded cursor-pointer" }
const _hoisted_13 = { class: "flex flex-col items-center justify-center" }
const _hoisted_14 = { class: "font-sourcesanspro-semibold text-sm2 text-white" }

import { computed, ref } from 'vue';
import { IonButton, IonContent, IonIcon } from '@ionic/vue';
import { cashOutline, chevronBackOutline, helpBuoyOutline, ticketOutline } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import { Wallet } from '@/shared/interfaces/balance';
import TopBar from '@/shared/components/TopBar.vue';
import useTenant from '@/shared/composables/useTenant';
import useUserProfile from '@/modules/profile/composables/useUserProfile';
import WalletBox from '@/shared/components/WalletBox.vue';
import useWallet from '@/modules/wallet/composables/useWallet';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'WalletManagePage',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();
const { getUserProfile } = useUserProfile();
const { userProfile } = getUserProfile();
const selectedWallet = ref();
const walletId = route.params.wallet_id?.toString();

const onWalletSet = (wallet: Wallet) => {
	selectedWallet.value = wallet;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            class: "w-[35px] h-[35px] text-black ion-no-padding ion-no-margin hover:bg-white hover:rounded-full",
            shape: "round"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "flex items-center justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(chevronBackOutline),
                    class: "ion-no-padding ion-no-margin text-black mr-[2px]"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        center: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('wallet.manage_wallet.title')), 1)
        ]),
        right: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", null, null, -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('wallet.manage_wallet.help')), 1)
        ]),
        (_unref(tenantConfig))
          ? (_openBlock(), _createBlock(WalletBox, {
              key: 0,
              user: `${_unref(userProfile)?.firstname} ${_unref(userProfile)?.lastname}`,
              onOnWalletSet: onWalletSet,
              "wallet-id": _unref(walletId)
            }, null, 8, ["user", "wallet-id"]))
          : _createCommentVNode("", true),
        (selectedWallet.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: `/wallet/history/${selectedWallet.value.id}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButton), { class: "flex flex-col items-center justify-center w-full h-full ion-no-padding ion-no-margin transparent" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_unref(IonIcon), {
                            class: "mt-1",
                            icon: _unref(cashOutline)
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('wallet.manage_wallet.transactions')), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              (_unref(tenantConfig)?.enable_refund)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: `/wallet/refunds/${selectedWallet.value.id}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonButton), { class: "flex flex-col items-center justify-center w-full h-full ion-no-padding ion-no-margin transparent" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_unref(IonIcon), {
                                class: "mt-1",
                                icon: _unref(helpBuoyOutline)
                              }, null, 8, ["icon"]),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('wallet.manage_wallet.request_refunds')), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_router_link, { to: "/top-up/redeem" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButton), { class: "flex flex-col items-center justify-center w-full h-full ion-no-padding ion-no-margin transparent" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_unref(IonIcon), {
                            class: "mt-1",
                            icon: _unref(ticketOutline)
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('top_up.redeem_voucher.redeem')), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})